import React from "react";
import "./reunite.scss";
import { Box, Container, Grid, Typography } from "@mui/material";

function ReunitePage() {
  const timelineData = [
    {
      id: 1,
      title: "The Separation",
      subtitle: "Crowds can overwhelm children and the elderly",
      description:
        "In the midst of thousands of devotees, a moment of distraction is all it takes. A child lets go of a hand or an elder falls behind, the crowd swallows them whole.",
      image: "/assets/reunite-page/story/step-1.webp",
    },
    {
      id: 2,
      title: "The Discovery",
      subtitle: "A stranger becomes a helper",
      description:
        "A kind pilgrim notices the child wearing the ReUnite Band. A quick scan of the wristband QR code with any phone camera no app required.",
      image: "/assets/reunite-page/story/step-2.webp",
    },
    {
      id: 3,
      title: "The Reunion",
      subtitle: "Family restored, journey continues",
      description:
        "Emergency contacts appear instantly. Within minutes the family is reunited, and the sacred pilgrimage continues with peace of mind.",
      image: "/assets/reunite-page/story/step-3.webp",
    },
  ];

  const steps = [
  {
    icon: "/assets/reunite-page/icons/register.svg",
    title: "Register Details",
    desc: "Add emergency contacts, medical info, blood group and allergies via the app.",
  },
  {
    icon: "/assets/reunite-page/icons/band.svg",
    title: "Get Your Band",
    desc: "Order a Reunite Band for each vulnerable family member before your pilgrimage.",
  },
  {
    icon: "/assets/reunite-page/icons/journey.svg",
    title: "Wear During Journey",
    desc: "Secure the waterproof band on the wrist which is comfortable enough for all-day wear.",
  },
  {
    icon: "/assets/reunite-page/icons/found.svg",
    title: "Scan If Found",
    desc: "Anyone can scan the QR code with any phone camera and no app is required for the finder.",
  },
];

const features = [
  {
    icon: "/assets/reunite-page/icons/qr.svg",
    title: "QR Code Security",
    description:
      "Anyone who finds a lost yatri can scan the band to instantly access emergency contact numbers.",
  },
  {
    icon: "/assets/reunite-page/icons/shield.svg",
    title: "For Vulnerable Yatris",
    description:
      "Perfect for small children and elderly family members who may get separated in crowded environments.",
  },
  {
    icon: "/assets/reunite-page/icons/medical.svg",
    title: "Vital Medical Info",
    description:
      "Stores crucial details like blood group and allergies for immediate medical assistance.",
  },
  {
    icon: "/assets/reunite-page/icons/mind.svg",
    title: "Peace of Mind",
    description:
      "Enjoy your spiritual journey knowing your loved ones are always within reach.",
  },
];
  return (
    <>
      <Box className="hero-banner reuniteBanner">
        <Container maxWidth="md">
          <Grid container justifyContent="center">
            <Grid size={12}>
              <div className="hero-content">
                <span className="badge-tag">Coming Soon</span>

                <h1>
                  Never Lose Your <br />
                  <span>Loved Ones</span>
                </h1>

                <p>
                  A smart wristband with a scannable QR code
                  <br />
                  that is designed to protect your family during
                  <br />
                  crowded spiritual journeys.
                </p>
              </div>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <section className="storyTimeline">
        <Container maxWidth="md">
          <Grid container spacing={4}>
            <Grid size={12}>
              <Box className="templeInnerHeading">
                <h2>The Journey of Reunion</h2>
                <p>
                  Every separation carries a story and every Reunite Band
                  writes a new ending.
                </p>
              </Box>

              {/* Timeline */}
              <Box className="timelineBar">
                <div className="line"></div>

                {timelineData.map((item) => (
                  <div key={item.id} className="step">
                    <span>{item.id}</span>
                  </div>
                ))}
              </Box>
            </Grid>

            {timelineData.map((item) => (
              <Grid
                key={item.id}
                size={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }}
              >
                <Box className="storyCard">
                  <div className="storyImage">
                    <img src={item.image} alt={item.title} />
                  </div>

                  <div className="storyContent">
                    <Typography variant="h5">{item.title}</Typography>

                    <Typography className="subHeading">
                      {item.subtitle}
                    </Typography>

                    <Typography className="description">
                      {item.description}
                    </Typography>
                  </div>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </section>

       <section className="howItWorks">
        <Container maxWidth="md">
          <Grid container spacing={4}>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <Box className="templeInnerHeading">
                <span>SIMPLE STEPS</span>
                <h2 className="mt-1">How It Works</h2>
              </Box>

              
            </Grid>

             {steps.map((item, index) => (
        <Grid
          key={index}
          size={{ xl: 3, lg: 3, md: 6, sm: 6, xs: 12 }}
        >
          <Box className="workCard">

            <div className="iconBox">
               <img src={item.icon} alt={item.title} height="25" width="25" />
              
            </div>

            <Typography variant="h6">
              {item.title}
            </Typography>

            <Typography className="description">
              {item.desc}
            </Typography>

          </Box>
        </Grid>
      ))}
          </Grid>
        </Container>
      </section>

       <section className="featureSection">
        <Container maxWidth="md">
          <Grid container spacing={4}>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <Box className="templeInnerHeading">
                <span>Sacred Shield</span>
                <h2 className="mt-1">Why Reunite Band?</h2>
                <p>Four layers of protection for every pilgrim.</p>
              </Box>

              
            </Grid>

             {features.map((item, index) => (
        <Grid
          key={index}
          size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }}
        >
          <Box className="featureCard">

            <div className="featureIcon">
               <img src={item.icon} alt={item.title}  height="25" width="25" />
              
            </div>

            <div className="featureContent">
              <h4>{item.title}</h4>
              <p>{item.description}</p>
            </div>

          </Box>
        </Grid>
      ))}
          </Grid>
        </Container>
      </section>


      <section className="feedbackSection">
  <Container maxWidth="md">
    <div className="feedbackCard">
      <Grid container spacing={3}>

        {/* Heading */}
        <Grid size={12}>
          <div className="feedbackHeader">
            <div className="iconBox">
             <img src="/assets/reunite-page/icons/feedback.svg" height="35" width="35" alt="Feedback" />
            </div>

            <div>
              <span>YOUR VOICE MATTERS</span>
              <h2>Share Your Thoughts</h2>
            </div>
          </div>

          <p className="question">
            Would you order this sacred shield for your family's next pilgrimage?
          </p>
        </Grid>

        {/* Textarea */}
        <Grid size={12}>
          <textarea
            className="feedbackTextarea"
            rows="5"
            placeholder="Any thoughts or suggestions? (Optional)"
          ></textarea>
        </Grid>

        {/* Buttons */}
        <Grid
          size={12}
          container
          spacing={3}
          justifyContent="center"
          className="mt-2"
        >
          <Grid size={{ xs: 12, sm: 6, md: 5 }}>
            <button className="yesBtn w-100">
              Yes, this is essential
            </button>
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 5 }}>
            <button className="noBtn w-100">
              Not right now
            </button>
          </Grid>
        </Grid>

        {/* Footer */}
        <Grid size={12}>
          <p className="thanksText mb-0 text-center">
            Thank you for sharing.
          </p>
        </Grid>

      </Grid>
    </div>
  </Container>
</section>
    </>
  );
}

export default ReunitePage;